import { Routes, Route} from "react-router-dom"
import {LayoutPage, GithubLogin, TokenPage, AdminTokenPage, NotFoundPage, AdminLocalLogin} from './pages'
import UserDashboard from './pages/UserDashboard'
import StorePage from './pages/StorePage'
import RepoDetails from './pages/RepoDetails'
import Contributions from './pages/Contributions'
import LearningResources from './pages/LearningResources'
import AdminLayout from './components/AdminLayout'
import AdminDashboard from './pages/AdminDashboard'
import ManageUsers from './pages/ManageUsers'
import ManageStore from './pages/ManageStore'
import ManageSponsors from './pages/ManageSponsors'
import ManageRedemptions from './pages/ManageRedemptions'
import ManageResources from './pages/ManageResources'
import ManageRepos from './pages/ManageRepos'

function App() {

  const auth = window.localStorage.getItem('auth')

  return (
    <div className="App">

      <Routes>
        {/* Public Routes */}
        <Route path="/admin/login" element={<AdminLocalLogin />} />
        <Route path="/admin/token" element={<AdminTokenPage />} />

        {/* User Routes */}
        <Route path="/" element={<LayoutPage />}>
          <Route index element={auth ? (<UserDashboard />) : (<GithubLogin />)} />
          <Route path="token" element={<TokenPage />} />
          <Route path="dashboard" element={<UserDashboard />} />
          <Route path="store" element={<StorePage />} />
          <Route path="contributions" element={<Contributions />} />
          <Route path="resources" element={<LearningResources />} />
          <Route path="repo/:owner/:name" element={<RepoDetails />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="repos" element={<ManageRepos />} />
          <Route path="store" element={<ManageStore />} />
          <Route path="sponsors" element={<ManageSponsors />} />
          <Route path="redemptions" element={<ManageRedemptions />} />
          <Route path="resources" element={<ManageResources />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App
